module.exports = __webpack_public_path__ + "static/media/settings.565c5586.svg";